import { PlusCircle } from '@hungryroot/icons';
import { Heading } from '@hungryroot/ramen';
import styles from './AddMore.module.css';

export enum StyleVariant {
  Small = 'small',
  Medium = 'medium',
}

type Props = {
  testid?: string;
  url: string;
  styleVariant: StyleVariant;
  className?: string;
};

export const AddMore = (props: Props) => {
  const { testid, url, styleVariant, className } = props;

  return (
    <a
      className={`${styles.container} ${
        styles[`add-more-${styleVariant}`]
      } ${className}`}
      data-testid={testid}
      href={url}
    >
      <PlusCircle />
      <Heading variant="H6">Add more</Heading>
    </a>
  );
};
